import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateSearch, updateQuickSearch } from "redux/actions";
import { providerSelector } from 'redux/selectors/providerSelectors';
import { placeholdersTxt, tooltipsTxt, mobilePlaceholdersTxt } from "../../common/filters";
import { ProviderIcon, TooltipContainer } from "../../components";
import { isMobile } from "../../common/widgets";
import { ProviderType, SubMenus, TabIndexType, Tabs } from "../../common/utils/TrackEventTypes";

const ProviderNameField = (props) => {
    const providerNameRef: any = useRef();
    const dispatch = useDispatch();
    const providerData = providerSelector;
    const searchTerm = useSelector(providerData.searchTerm);
    const selectedProviderType = useSelector(providerData.selectedProviderType);
    const providerType = useSelector(providerData.selectedProviderType);
    const tabIndex = useSelector(providerData.tabIndex);
    const [providerName, setProviderName] = useState(searchTerm);

    useEffect(() => {
        setProviderName(searchTerm)
    }, [searchTerm])

    useEffect(() => {
        if (providerName !== searchTerm) {
            if (tabIndex === 0) {
                dispatch(updateSearch({
                    guidedSearch: { searchTerm: providerName }
                }))
            } else {
                dispatch(updateQuickSearch({
                    quickSearch: { searchTerm: providerName }
                }))
            }
        }
    }, [providerName])

    const ph = isMobile() ? mobilePlaceholdersTxt : placeholdersTxt;

    const handleChange = (event: { target: { value: string; }; }) => {
        setProviderName(event.target?.value);
    }

    const getTooltip = () => {
        return props.selectedProviderType === 2 ? tooltipsTxt.searchTermForFacilities : tooltipsTxt.providerName;
    }

    return (
        <div className="fieldgroup__container">
            <div className="fieldgroup__placeholder">
                <div className="fieldgroup__placeholder-title">
                    {props.fieldText || 'Search Term (optional)'}
                </div>
                <TooltipContainer
                    position="BottomCenter"
                    content={getTooltip()}
                    eventDetails={{
                        menu: Tabs[tabIndex as TabIndexType],
                        subMenu: SubMenus[providerType as ProviderType],
                        toolTipFor: "Search Term (optional)",
                        content: getTooltip(),
                    }}
                >
                    <div className="fieldgroup__placeholder-icon">
                        {ProviderIcon['tooltip']}
                    </div>
                </TooltipContainer>
            </div>

            <div className="fieldgroup__field">
                <input ref={providerNameRef} className="fieldgroup__field-input" placeholder={(tabIndex === 0 && selectedProviderType === 2) ? ph.providerNameFacility : ph.providerNameDoctor} onChange={handleChange} value={providerName || ''} />
            </div>
        </div>
    )
}

export default ProviderNameField;